(function () {
  'use strict';

  if (window.AN_CART_POPUP_FIX_V8_LOADED) return;
  window.AN_CART_POPUP_FIX_V8_LOADED = true;

  /*
    Bloquea scripts anteriores que hayamos probado para que no compitan.
  */
  window.AN_FINAL_CART_DRAWER_FIX_LOADED = true;
  window.AN_AJAX_CART_DRAWER_FINAL = true;
  window.AN_AJAX_CART_DRAWER_DEFINITIVO = true;
  window.NCCollectionAddToCartLoaded = true;
  window.NCCarouselAddToCartLoaded = true;

  var ADD_FORM_SELECTOR = [
    'form[action*="/cart/add"]',
    'form[action*="/cart/add.js"]',
    '.an-cg-card__form',
    '.nc-card__form',
    '.nc-pc__form',
    '.nc-prc__form'
  ].join(',');

  var ADD_CONTROL_SELECTOR = [
    'form[action*="/cart/add"] button[type="submit"]',
    'form[action*="/cart/add"] button[name="add"]',
    'form[action*="/cart/add"] #AddToCart',
    'form[action*="/cart/add"] .product-form__submit',
    'form[action*="/cart/add"] .ap-text-loaderbutton',
    'form[action*="/cart/add"] .button',
    'form[action*="/cart/add"] .btn',

    'a[href*="/cart/add"]',
    'a[href*="/cart/add.js"]',

    'button[data-variant-id]',
    'button[data-variant]',
    'button[data-id]',
    'a[data-variant-id]',
    'a[data-variant]',
    'a[data-id]',

    '.an-cg-card__button',
    '.nc-card__button',
    '.nc-pc__button',
    '.nc-prc__button'
  ].join(',');

  function getRoutes() {
    var cartAddUrl =
      window.themeVariables &&
      window.themeVariables.routes &&
      window.themeVariables.routes.cartAddUrl
        ? window.themeVariables.routes.cartAddUrl
        : window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : '/cart/add';

    var cartUrl =
      window.themeVariables &&
      window.themeVariables.routes &&
      window.themeVariables.routes.cartUrl
        ? window.themeVariables.routes.cartUrl
        : window.routes && window.routes.cart_url
          ? window.routes.cart_url
          : '/cart';

    return {
      cartAddJson: cartAddUrl.replace(/\.js$/, '') + '.js',
      cartJson: cartUrl.replace(/\.js$/, '') + '.js',
      cartPage: cartUrl
    };
  }

  function route(path) {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return root.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function textOf(element) {
    return (element && element.textContent ? element.textContent : '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isViewOptions(element) {
    var text = textOf(element);

    return (
      text.indexOf('ver opciones') !== -1 ||
      text.indexOf('opciones') !== -1 ||
      text.indexOf('agotado') !== -1 ||
      text.indexOf('sold out') !== -1
    );
  }

  function isDynamicCheckout(element) {
    if (!element) return false;

    return Boolean(
      element.closest('.shopify-payment-button') ||
      element.classList.contains('shopify-payment-button__button') ||
      element.getAttribute('name') === 'checkout' ||
      element.getAttribute('data-testid') === 'Checkout-button'
    );
  }

  function getVariantFromElement(element) {
    if (!element) return null;

    return (
      element.getAttribute('data-variant-id') ||
      element.getAttribute('data-variant') ||
      element.getAttribute('data-id') ||
      element.dataset.variantId ||
      element.dataset.variant ||
      element.dataset.id ||
      null
    );
  }

  function getQuantityFromElement(element) {
    if (!element) return 1;

    var value =
      element.getAttribute('data-quantity') ||
      element.dataset.quantity ||
      1;

    value = parseInt(value, 10);

    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function getFormFromControl(control) {
    if (!control) return null;

    var form = control.closest('form[action*="/cart/add"], form[action*="/cart/add.js"]');

    if (form) return form;

    var card = control.closest(
      '.product-card, .product-item, .grid__item, .card, .an-cg-card, .nc-card, .nc-pc, .nc-prc, [data-product-id], [data-product-handle]'
    );

    if (card) {
      form = card.querySelector('form[action*="/cart/add"], form[action*="/cart/add.js"]');
      if (form) return form;
    }

    return null;
  }

  function getVariantFromForm(form) {
    if (!form) return null;

    var input = form.querySelector('[name="id"]');

    return input && input.value ? input.value : null;
  }

  function getQuantityFromForm(form) {
    if (!form) return 1;

    var input = form.querySelector('[name="quantity"]');
    var quantity = input ? parseInt(input.value, 10) : 1;

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function parseCartAddHref(element) {
    if (!element) return null;

    var href = element.getAttribute('href');

    if (!href || href.indexOf('/cart/add') === -1) return null;

    try {
      var url = new URL(href, window.location.origin);
      var id = url.searchParams.get('id');
      var quantity = url.searchParams.get('quantity') || 1;
      var sellingPlan = url.searchParams.get('selling_plan') || '';

      if (!id) return null;

      return {
        id: id,
        quantity: quantity,
        sellingPlan: sellingPlan
      };
    } catch (error) {
      return null;
    }
  }

  function buildPayloadFromForm(form) {
    var variantId = getVariantFromForm(form);

    if (!variantId) return null;

    var formData = new FormData(form);

    formData.set('id', variantId);

    if (!formData.get('quantity')) {
      formData.set('quantity', getQuantityFromForm(form));
    }

    formData.set('sections', 'mini-cart');
    formData.set('sections_url', window.location.pathname);

    formData.delete('option1');
    formData.delete('option2');
    formData.delete('option3');

    return formData;
  }

  function buildPayloadFromControl(control) {
    var form = getFormFromControl(control);

    if (form) {
      return buildPayloadFromForm(form);
    }

    var hrefData = parseCartAddHref(control);

    if (hrefData && hrefData.id) {
      var hrefPayload = new FormData();

      hrefPayload.set('id', hrefData.id);
      hrefPayload.set('quantity', hrefData.quantity || 1);
      hrefPayload.set('sections', 'mini-cart');
      hrefPayload.set('sections_url', window.location.pathname);

      if (hrefData.sellingPlan) {
        hrefPayload.set('selling_plan', hrefData.sellingPlan);
      }

      return hrefPayload;
    }

    var variantId = getVariantFromElement(control);

    if (variantId) {
      var dataPayload = new FormData();

      dataPayload.set('id', variantId);
      dataPayload.set('quantity', getQuantityFromElement(control));
      dataPayload.set('sections', 'mini-cart');
      dataPayload.set('sections_url', window.location.pathname);

      return dataPayload;
    }

    return null;
  }

  function setLoading(control, loading) {
    if (!control) return;

    if (loading) {
      if (!control.dataset.anOriginalHtml) {
        control.dataset.anOriginalHtml = control.innerHTML;
      }

      control.setAttribute('aria-busy', 'true');
      control.classList.add('is-loading', 'an-cart-loading');

      if ('disabled' in control) {
        control.disabled = true;
      }
    } else {
      if (control.dataset.anOriginalHtml) {
        control.innerHTML = control.dataset.anOriginalHtml;
        delete control.dataset.anOriginalHtml;
      }

      control.removeAttribute('aria-busy');
      control.classList.remove('is-loading', 'an-cart-loading');

      if ('disabled' in control) {
        control.disabled = false;
      }
    }
  }

  function setSuccess(control) {
    if (!control) return;

    var original = control.dataset.anOriginalHtml || control.innerHTML;

    control.classList.remove('is-loading', 'an-cart-loading');
    control.classList.add('an-cart-added');
    control.innerHTML = 'Agregado';

    window.setTimeout(function () {
      control.classList.remove('an-cart-added');
      control.innerHTML = original;
      control.removeAttribute('aria-busy');

      if ('disabled' in control) {
        control.disabled = false;
      }

      delete control.dataset.anOriginalHtml;
    }, 1100);
  }

  function setError(control) {
    if (!control) return;

    var original = control.dataset.anOriginalHtml || control.innerHTML;

    control.classList.remove('is-loading', 'an-cart-loading');
    control.classList.add('an-cart-error');
    control.innerHTML = 'Intenta de nuevo';

    window.setTimeout(function () {
      control.classList.remove('an-cart-error');
      control.innerHTML = original;
      control.removeAttribute('aria-busy');

      if ('disabled' in control) {
        control.disabled = false;
      }

      delete control.dataset.anOriginalHtml;
    }, 1400);
  }

  async function getCartJson() {
    var routes = getRoutes();

    var response = await fetch(routes.cartJson, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) return null;

    return response.json();
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    document.querySelectorAll(
      [
        '[data-cart-count]',
        '.cart-count',
        '.cart-count-bubble',
        '.cart-link__bubble',
        '.header__cart-count',
        '.ap-cartcount',
        '.cart-item-count',
        '.cart__count'
      ].join(',')
    ).forEach(function (element) {
      element.textContent = cart.item_count;
      element.classList.toggle('hidden', cart.item_count === 0);
      element.classList.toggle('is-empty', cart.item_count === 0);
    });
  }

  function dispatchCartEvents(addResponse, cart) {
    var detail = {
      cart: addResponse,
      fullCart: cart,
      openMiniCart: true
    };

    [
      'cart:refresh',
      'cart:updated',
      'theme:cart:updated',
      'theme:cart:open',
      'ajaxProduct:added',
      'product:added',
      'cart:added'
    ].forEach(function (eventName) {
      document.dispatchEvent(
        new CustomEvent(eventName, {
          bubbles: true,
          detail: detail
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent(eventName, {
          bubbles: true,
          detail: detail
        })
      );
    });
  }

  function getMiniCartDrawer() {
    return (
      document.querySelector('ap-cartdrawer#mini-cart') ||
      document.querySelector('#mini-cart') ||
      document.querySelector('ap-cartdrawer') ||
      document.querySelector('[data-mini-cart]') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('.mini-cart') ||
      document.querySelector('.cart-drawer')
    );
  }

  function clickThemeCartTrigger() {
    var trigger = document.querySelector(
      [
        '[aria-controls="mini-cart"]',
        '[aria-controls="MiniCart"]',
        '[aria-controls="cart-drawer"]',
        '[aria-controls="CartDrawer"]',
        '[data-action="open-cart"]',
        '[data-action="toggle-cart"]',
        '[data-open-cart]',
        '[data-cart-drawer-open]',
        '.js-cart-drawer-open',
        '.header__cart[aria-controls]',
        '.header__icon--cart[aria-controls]',
        '.cart-link[aria-controls]'
      ].join(',')
    );

    if (!trigger) return false;

    trigger.click();
    return true;
  }

  function forceOpenThemeDrawer() {
    var drawer = getMiniCartDrawer();

    if (!drawer) {
      return clickThemeCartTrigger();
    }

    try {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
    } catch (error) {}

    try {
      drawer.open = true;
    } catch (error) {
      drawer.setAttribute('open', '');
    }

    drawer.setAttribute('open', '');
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');

    drawer.classList.add(
      'is-open',
      'open',
      'active',
      'drawer--open',
      'cart-drawer--open'
    );

    document.documentElement.classList.add(
      'ap-lockall',
      'cart-open',
      'mini-cart-open',
      'cart-drawer-open'
    );

    document.body.classList.add(
      'cart-open',
      'mini-cart-open',
      'cart-drawer-open',
      'overflow-hidden'
    );

    return true;
  }

  function injectFallbackDrawerStyles() {
    if (document.getElementById('an-fallback-cart-drawer-style')) return;

    var style = document.createElement('style');
    style.id = 'an-fallback-cart-drawer-style';

    style.textContent = ''
      + '.an-fallback-cart-overlay{position:fixed;inset:0;z-index:999998;background:rgba(0,0,0,.45);opacity:0;visibility:hidden;transition:.22s ease;}'
      + '.an-fallback-cart-overlay.is-open{opacity:1;visibility:visible;}'
      + '.an-fallback-cart-drawer{position:fixed;top:0;right:0;z-index:999999;width:min(440px,calc(100vw - 12px));height:100vh;background:#fffaf2;border-left:1px solid #eadfcb;box-shadow:-18px 0 70px rgba(0,0,0,.22);transform:translateX(110%);transition:transform .26s ease;display:flex;flex-direction:column;font-family:inherit;}'
      + '.an-fallback-cart-drawer.is-open{transform:translateX(0);}'
      + '.an-fallback-cart-head{padding:22px;border-bottom:1px solid #eadfcb;display:flex;align-items:center;justify-content:space-between;gap:16px;}'
      + '.an-fallback-cart-title{margin:0;color:#050505;font-size:24px;line-height:1;font-weight:950;text-transform:uppercase;letter-spacing:-.04em;}'
      + '.an-fallback-cart-close{width:42px;height:42px;border-radius:999px;border:1px solid #050505;background:#050505;color:#f5b400;font-size:25px;font-weight:900;line-height:1;cursor:pointer;}'
      + '.an-fallback-cart-body{flex:1;overflow:auto;padding:18px 22px;display:grid;gap:12px;align-content:start;}'
      + '.an-fallback-cart-success{margin:0 0 4px;padding:13px 15px;border-radius:18px;background:#050505;color:#f5b400;text-align:center;font-size:14px;font-weight:900;line-height:1.2;}'
      + '.an-fallback-cart-item{display:grid;grid-template-columns:74px 1fr;gap:13px;padding:12px;border-radius:18px;border:1px solid #eadfcb;background:#fff;box-shadow:0 10px 26px rgba(0,0,0,.045);}'
      + '.an-fallback-cart-img{width:74px;height:74px;object-fit:contain;border-radius:14px;background:#f7f4ee;border:1px solid #eee4d5;}'
      + '.an-fallback-cart-name{margin:0 0 7px;color:#111;font-size:14px;line-height:1.25;font-weight:900;}'
      + '.an-fallback-cart-meta{margin:0;color:#6f6a61;font-size:13px;line-height:1.35;font-weight:700;}'
      + '.an-fallback-cart-foot{padding:18px 22px 22px;border-top:1px solid #eadfcb;background:radial-gradient(circle at 100% 0%,rgba(245,180,0,.14),transparent 36%),#fffaf2;}'
      + '.an-fallback-cart-total{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-bottom:14px;color:#050505;font-size:17px;font-weight:950;}'
      + '.an-fallback-cart-actions{display:grid;gap:10px;}'
      + '.an-fallback-cart-checkout,.an-fallback-cart-page{display:flex;align-items:center;justify-content:center;min-height:54px;border-radius:999px;text-decoration:none;font-size:14px;line-height:1;font-weight:950;letter-spacing:.06em;text-transform:uppercase;}'
      + '.an-fallback-cart-checkout{background:#050505;color:#fff;}'
      + '.an-fallback-cart-page{background:#f5b400;color:#050505;}';

    document.head.appendChild(style);
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat('es-GT', {
        style: 'currency',
        currency: 'GTQ',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount).replace('GTQ', 'Q').trim();
    } catch (error) {
      return 'Q ' + amount.toFixed(amount % 1 === 0 ? 0 : 2);
    }
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function ensureFallbackDrawer() {
    injectFallbackDrawerStyles();

    var overlay = document.querySelector('.an-fallback-cart-overlay');
    var drawer = document.querySelector('.an-fallback-cart-drawer');

    if (overlay && drawer) {
      return {
        overlay: overlay,
        drawer: drawer
      };
    }

    overlay = document.createElement('div');
    overlay.className = 'an-fallback-cart-overlay';

    drawer = document.createElement('aside');
    drawer.className = 'an-fallback-cart-drawer';
    drawer.setAttribute('aria-hidden', 'true');

    drawer.innerHTML = ''
      + '<div class="an-fallback-cart-head">'
      + '<h2 class="an-fallback-cart-title">Carrito</h2>'
      + '<button type="button" class="an-fallback-cart-close" aria-label="Cerrar carrito">×</button>'
      + '</div>'
      + '<div class="an-fallback-cart-body">'
      + '<p class="an-fallback-cart-success">Producto agregado al carrito.</p>'
      + '<div class="an-fallback-cart-items"></div>'
      + '</div>'
      + '<div class="an-fallback-cart-foot">'
      + '<div class="an-fallback-cart-total"><span>Total</span><strong data-an-fallback-total>Q 0</strong></div>'
      + '<div class="an-fallback-cart-actions">'
      + '<a class="an-fallback-cart-checkout" href="/checkout">Finalizar compra</a>'
      + '<a class="an-fallback-cart-page" href="/cart">Ver carrito</a>'
      + '</div>'
      + '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    overlay.addEventListener('click', closeFallbackDrawer);
    drawer.querySelector('.an-fallback-cart-close').addEventListener('click', closeFallbackDrawer);

    return {
      overlay: overlay,
      drawer: drawer
    };
  }

  function renderFallbackDrawer(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    var parts = ensureFallbackDrawer();
    var itemsContainer = parts.drawer.querySelector('.an-fallback-cart-items');
    var total = parts.drawer.querySelector('[data-an-fallback-total]');

    itemsContainer.innerHTML = cart.items.map(function (item) {
      var image = item.image || '';
      var title = escapeHtml(item.product_title || item.title || 'Producto');
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? escapeHtml(item.variant_title)
        : '';
      var quantity = item.quantity || 1;
      var linePrice = formatMoney(item.final_line_price || item.line_price || item.price || 0);

      return ''
        + '<article class="an-fallback-cart-item">'
        + '<img class="an-fallback-cart-img" src="' + image + '" alt="' + title + '" loading="lazy">'
        + '<div>'
        + '<h3 class="an-fallback-cart-name">' + title + '</h3>'
        + '<p class="an-fallback-cart-meta">'
        + (variant ? variant + '<br>' : '')
        + 'Cantidad: ' + quantity + '<br>'
        + linePrice
        + '</p>'
        + '</div>'
        + '</article>';
    }).join('');

    total.textContent = formatMoney(cart.total_price || 0);
  }

  function openFallbackDrawer(cart) {
    var parts = ensureFallbackDrawer();

    renderFallbackDrawer(cart);

    parts.overlay.classList.add('is-open');
    parts.drawer.classList.add('is-open');
    parts.drawer.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('cart-open', 'mini-cart-open');
    document.body.classList.add('cart-open', 'mini-cart-open');
  }

  function closeFallbackDrawer() {
    var overlay = document.querySelector('.an-fallback-cart-overlay');
    var drawer = document.querySelector('.an-fallback-cart-drawer');

    if (overlay) overlay.classList.remove('is-open');

    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    document.documentElement.classList.remove('cart-open', 'mini-cart-open');
    document.body.classList.remove('cart-open', 'mini-cart-open');
  }

  function showNotice(message, type) {
    var notice = document.querySelector('[data-an-cart-notice]');

    if (!notice) {
      notice = document.createElement('div');
      notice.setAttribute('data-an-cart-notice', '');
      notice.style.position = 'fixed';
      notice.style.left = '50%';
      notice.style.bottom = '24px';
      notice.style.zIndex = '999999';
      notice.style.maxWidth = 'calc(100vw - 32px)';
      notice.style.padding = '14px 18px';
      notice.style.borderRadius = '999px';
      notice.style.fontSize = '14px';
      notice.style.fontWeight = '900';
      notice.style.lineHeight = '1.2';
      notice.style.textAlign = 'center';
      notice.style.boxShadow = '0 18px 44px rgba(0,0,0,.18)';
      notice.style.transform = 'translateX(-50%) translateY(8px)';
      notice.style.opacity = '0';
      notice.style.transition = 'opacity .2s ease, transform .2s ease';
      notice.style.pointerEvents = 'none';

      document.body.appendChild(notice);
    }

    notice.textContent = message;
    notice.style.background = type === 'error' ? '#B42318' : '#050505';
    notice.style.color = type === 'error' ? '#FFFFFF' : '#f5b400';
    notice.style.opacity = '1';
    notice.style.transform = 'translateX(-50%) translateY(0)';

    clearTimeout(notice.__anTimer);

    notice.__anTimer = window.setTimeout(function () {
      notice.style.opacity = '0';
      notice.style.transform = 'translateX(-50%) translateY(8px)';
    }, 2300);
  }

  async function postAddToCart(payload) {
    var routes = getRoutes();

    var response = await fetch(routes.cartAddJson, {
      method: 'POST',
      credentials: 'same-origin',
      body: payload,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    var json = await response.json();

    if (!response.ok || json.status) {
      throw new Error(
        json.description ||
        json.message ||
        'No se pudo agregar el producto.'
      );
    }

    return json;
  }

  async function addToCart(control, payload) {
    if (!control || !payload) return;
    if (control.dataset.anAdding === 'true') return;

    control.dataset.anAdding = 'true';
    setLoading(control, true);

    try {
      var addResponse = await postAddToCart(payload);
      var cart = await getCartJson();

      if (cart) {
        updateCartCount(cart);
      }

      dispatchCartEvents(addResponse, cart);

      window.setTimeout(function () {
        var opened = forceOpenThemeDrawer();

        if (!opened && cart) {
          openFallbackDrawer(cart);
        }

        if (!opened && !cart) {
          showNotice('Producto agregado al carrito.', 'success');
        }
      }, 120);

      window.setTimeout(function () {
        forceOpenThemeDrawer();
      }, 420);

      setSuccess(control);
    } catch (error) {
      console.error('Error al agregar al carrito:', error);
      setError(control);
      showNotice(error.message || 'No se pudo agregar el producto.', 'error');
    } finally {
      control.dataset.anAdding = 'false';
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var control = event.target.closest(ADD_CONTROL_SELECTOR);

      if (!control) return;
      if (isDynamicCheckout(control)) return;
      if (isViewOptions(control)) return;

      var payload = buildPayloadFromControl(control);

      if (!payload) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addToCart(control, payload);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form =
        event.target &&
        event.target.matches('form[action*="/cart/add"], form[action*="/cart/add.js"]')
          ? event.target
          : null;

      if (!form) return;

      var control =
        event.submitter ||
        form.querySelector(
          'button[type="submit"], button[name="add"], #AddToCart, .product-form__submit, .ap-text-loaderbutton, .button, .btn'
        );

      if (control && isDynamicCheckout(control)) return;
      if (control && isViewOptions(control)) return;

      var payload = buildPayloadFromForm(form);

      if (!payload) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addToCart(control || form, payload);
    },
    true
  );
})();


/* ==========================================================
   BADGE DE PRECIO JUNTO AL PRECIO
   Mantiene la función anterior sin afectar el carrito.
========================================================== */

(function () {
  'use strict';

  if (window.AN_PRICE_BADGE_READY) return;
  window.AN_PRICE_BADGE_READY = true;

  var CONFIG = {
    badgeDesktopSize: 96,
    badgeMobileSize: 72,
    badgeGap: 16,
    mobileBreakpoint: 749
  };

  function injectStyles() {
    if (document.getElementById('an-price-badge-style')) return;

    var style = document.createElement('style');
    style.id = 'an-price-badge-style';

    style.textContent = ''
      + '.an-price-badge-row{display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:' + CONFIG.badgeGap + 'px!important;width:100%!important;margin:14px 0 18px!important;}'
      + '.an-price-badge-row .ap-productmeta__price-list-container,.an-price-badge-row .price{margin:0!important;}'
      + '.an-price-badge-row .price{display:flex!important;align-items:center!important;flex-wrap:wrap!important;gap:8px!important;}'
      + '.an-price-badge{width:' + CONFIG.badgeDesktopSize + 'px!important;max-width:' + CONFIG.badgeDesktopSize + 'px!important;min-width:' + CONFIG.badgeDesktopSize + 'px!important;height:' + CONFIG.badgeDesktopSize + 'px!important;margin:0!important;padding:0!important;display:flex!important;align-items:center!important;justify-content:center!important;flex:0 0 ' + CONFIG.badgeDesktopSize + 'px!important;border-radius:999px!important;overflow:hidden!important;background:transparent!important;}'
      + '.an-price-badge .product-nutrition-image__media,.an-price-badge img{width:100%!important;height:100%!important;max-width:100%!important;object-fit:contain!important;display:block!important;}'
      + '.an-price-badge + .product-nutrition-image,.product__info > .product-nutrition-image[data-an-price-badge-moved="true"]{margin:0!important;}'
      + '@media screen and (max-width:' + CONFIG.mobileBreakpoint + 'px){.an-price-badge-row{gap:12px!important;margin:12px 0 16px!important;align-items:center!important;}.an-price-badge{width:' + CONFIG.badgeMobileSize + 'px!important;max-width:' + CONFIG.badgeMobileSize + 'px!important;min-width:' + CONFIG.badgeMobileSize + 'px!important;height:' + CONFIG.badgeMobileSize + 'px!important;flex-basis:' + CONFIG.badgeMobileSize + 'px!important;}.an-price-badge-row .price{font-size:24px!important;line-height:1.1!important;}}';

    document.head.appendChild(style);
  }

  function getProductInfo() {
    return document.querySelector('.product__info');
  }

  function getPriceContainer(productInfo) {
    if (!productInfo) return null;

    return (
      productInfo.querySelector('.ap-productmeta__price-list-container') ||
      productInfo.querySelector('.price') ||
      null
    );
  }

  function getBadgeImage(productInfo) {
    if (!productInfo) return null;

    return (
      productInfo.querySelector('.product-nutrition-image[data-an-price-badge="true"]') ||
      productInfo.querySelector('.product-nutrition-image:not(.an-price-badge)')
    );
  }

  function moveBadgeNextToPrice() {
    injectStyles();

    var productInfo = getProductInfo();
    if (!productInfo) return false;

    var priceContainer = getPriceContainer(productInfo);
    var badge = getBadgeImage(productInfo);

    if (!priceContainer || !badge) return false;

    if (badge.classList.contains('an-price-badge')) return true;

    var row = productInfo.querySelector('.an-price-badge-row');

    if (!row) {
      row = document.createElement('div');
      row.className = 'an-price-badge-row';

      priceContainer.parentNode.insertBefore(row, priceContainer);
      row.appendChild(priceContainer);
    }

    badge.classList.add('an-price-badge');
    badge.setAttribute('data-an-price-badge', 'true');
    badge.setAttribute('data-an-price-badge-moved', 'true');

    row.appendChild(badge);

    return true;
  }

  function initWithRetries() {
    var attempts = 0;

    var timer = window.setInterval(function () {
      attempts += 1;

      var done = moveBadgeNextToPrice();

      if (done || attempts >= 30) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function observeProductInfo() {
    var productInfo = getProductInfo();

    if (!productInfo) return;

    var observer = new MutationObserver(function () {
      moveBadgeNextToPrice();
    });

    observer.observe(productInfo, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWithRetries();
    observeProductInfo();
  });

  document.addEventListener('shopify:section:load', function () {
    initWithRetries();
    observeProductInfo();
  });
})();